import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyBilling.vue?vue&type=template&id=71f9f7e0"
import script from "./MoleculeEditionBillingAcademyBilling.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports